import {combineReducers} from 'redux';

import type {ReportRowData, ComparedActivityReportSummary} from 'nutshell-core/types';

import * as actions from './task-report-actions';

type State = {
    data: string | null | undefined;
    hasError: boolean;
    isLoading: boolean;
    numPages: number | null | undefined;
};
const defaultState = {
    data: null,
    hasError: false,
    isLoading: true,
    numPages: null,
} as const;

type SummaryState = {
    hasError: boolean;
    isLoading: boolean;
    data: ComparedActivityReportSummary<Array<ReportRowData>> | null | undefined;
    totals: ComparedActivityReportSummary<ReportRowData> | null | undefined;
};
const defaultSummaryState = {
    ...defaultState,
    totals: null,
} as const;

export const summaryReducer = (
    state: SummaryState | null | undefined = defaultSummaryState,
    action: actions.TaskReportAction
): SummaryState => {
    switch (action.type) {
        case actions.ActionTypes.TASK_REPORT_FETCH_SUMMARY_REQUEST:
            // @ts-expect-error
            return {...state, isLoading: true};
        case actions.ActionTypes.TASK_REPORT_FETCH_SUMMARY_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                totals: action.payload.totals,
                isLoading: false,
                hasError: false,
            };
        case actions.ActionTypes.TASK_REPORT_FETCH_SUMMARY_FAILURE:
            // @ts-expect-error
            return {...state, isLoading: false, hasError: true};
        default:
            // @ts-expect-error
            return state;
    }
};

type LeadOutcomesState =
    | {
          lostOrCancelled: number;
          won: number;
          unknown: number;
      }
    | null
    | undefined;

export const leadOutcomesReducer = (
    state: LeadOutcomesState | null | undefined = null,
    action: {
        type: string;
        payload: any;
    }
): LeadOutcomesState => {
    switch (action.type) {
        case 'REPORT_TASK_SUMMARY_STATS_UPDATED':
            return null;
        case 'REPORTS_LEADS_REPORT_DATA_REQUESTED':
            return null;
        default:
            return state;
    }
};

export const taskReportReducer = combineReducers({
    summary: summaryReducer,
    leadOutcomes: leadOutcomesReducer,
});

export type TaskReportState = {
    detail: State;
    summary: SummaryState;
    leadOutcomes: LeadOutcomesState;
};
